import React, { useState } from 'react';
import { trackEvent } from '../analytics';

const sha256Hex = async (text) => {
  const buffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return [...new Uint8Array(buffer)].map((b) => b.toString(16).padStart(2, '0')).join('');
};

const LabLockGate = ({ slug, hash, onUnlock }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (busy || !value.trim()) return;
    setBusy(true);
    const attempt = await sha256Hex(value.trim());
    if (attempt === hash.toLowerCase()) {
      sessionStorage.setItem(`lab-unlocked:${slug}`, '1');
      trackEvent('Labs', 'unlock', slug);
      onUnlock();
    } else {
      setError(true);
      trackEvent('Labs', 'unlock-failed', slug);
    }
    setBusy(false);
  };

  return (
    <div className="lab-lock">
      <svg className="lab-lock-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
        <path d="M208,82H174V56a46,46,0,0,0-92,0V82H48A14,14,0,0,0,34,96V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V96A14,14,0,0,0,208,82ZM94,56a34,34,0,0,1,68,0V82H94ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z"></path>
      </svg>
      <div className="text-meta">Password required</div>
      <form className="lab-lock-form" onSubmit={handleSubmit}>
        <input
          type="password"
          className="lab-lock-input"
          placeholder="Password"
          aria-label="Password"
          autoFocus
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            setError(false);
          }}
        />
        <button type="submit" className="lab-lock-submit">
          Unlock
        </button>
      </form>
      {error ? <div className="lab-lock-error text-meta">Wrong password, try again.</div> : null}
    </div>
  );
};

export default LabLockGate;
